import Reflux from "reflux";
import i18n from "i18n";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
export const ForwarderInputTypesActions = Reflux.createActions({
  list: { asyncResult: true },
  get: { asyncResult: true }
});
const ForwarderInputTypesStore = Reflux.createStore({
  listenables: [ForwarderInputTypesActions],
  sourceUrl: "/plugins/org.graylog.plugins.forwarder/forwarder/inputs/types",
  forwarderInputTypes: void 0,
  forwarderInputDescriptions: void 0,
  init() {
    this.list();
  },
  getInitialState() {
    return {
      forwarderInputTypes: this.forwarderInputTypes,
      forwarderInputDescriptions: this.forwarderInputDescriptions
    };
  },
  list() {
    const promiseTypes = fetch("GET", qualifyUrl(this.sourceUrl));
    const promiseDescriptions = fetch("GET", qualifyUrl(`${this.sourceUrl}/all`));
    const promise = Promise.all([promiseTypes, promiseDescriptions]);
    promise.then(
      ([typesResponse, descriptionsResponse]) => {
        this.forwarderInputTypes = typesResponse.types;
        this.forwarderInputDescriptions = descriptionsResponse;
        this.trigger(this.getInitialState());
      },
      (error) => {
        UserNotification.error(
          i18n.t("notifications.input_types_fetch_failed", { ns: "enterprise_forwarder", error }),
          i18n.t("notifications.input_types_fetch_failed_title", { ns: "enterprise_forwarder" })
        );
      }
    );
    ForwarderInputTypesActions.list.promise(promise);
  },
  get(inputTypeId) {
    const promise = fetch("GET", qualifyUrl(`${this.sourceUrl}/${inputTypeId}`));
    promise.catch((error) => {
      UserNotification.error(
        i18n.t("notifications.input_type_fetch_failed", { ns: "enterprise_forwarder", inputTypeId, error }),
        i18n.t("notifications.input_type_fetch_failed_title", { ns: "enterprise_forwarder" })
      );
    });
    ForwarderInputTypesActions.get.promise(promise);
  }
});
export default ForwarderInputTypesStore;
